/** Operations dashboard daily-task types shown as individual priorities (not grouped as Updates). */
export const OPERATIONS_DASHBOARD_PRIORITY_TYPES = [
  'Add Service Providers',
  'Review Accommodation Task Template',
  'Review Common Task Template',
  'Create Tasks for Project'
];

const OPERATIONS_TASK_TEMPLATE_TAB_BY_TYPE = {
  'Review Common Task Template': 'common',
  'Review Accommodation Task Template': 'independent'
};

/** Marked completed when user opens Task Template from the operations dashboard. */
export const OPERATIONS_AUTO_COMPLETE_ON_REDIRECT_TYPES = [
  'Review Accommodation Task Template',
  'Review Common Task Template'
];

export function isOperationsDashboardPriorityType(type) {
  return OPERATIONS_DASHBOARD_PRIORITY_TYPES.includes(type);
}

/** Task Management → Task Template sub-tab for operations review priorities. */
export function getOperationsPriorityTemplateTab(taskType) {
  return OPERATIONS_TASK_TEMPLATE_TAB_BY_TYPE[taskType] ?? null;
}

export function shouldAutoCompleteOperationsPriorityOnRedirect(taskType) {
  return OPERATIONS_AUTO_COMPLETE_ON_REDIRECT_TYPES.includes(taskType);
}

/** Pending daily tasks for the current user matching an operations priority type. */
export function getPendingOperationsDailyTasks(prioritiesData, taskType, userId) {
  if (!Array.isArray(prioritiesData)) return [];
  return prioritiesData.filter(
    (item) =>
      item.type === taskType &&
      Number(item.user_id) === Number(userId) &&
      item.status !== 'Completed'
  );
}

export function getOperationsPriorityNavigation(taskType) {
  if (taskType === 'Add Service Providers') {
    return { path: '/builder/operations/service-providers' };
  }

  if (taskType === 'Create Tasks for Project') {
    return {
      path: '/builder/operations/tasks'
    };
  }

  const templateTab = getOperationsPriorityTemplateTab(taskType);
  if (!templateTab) return null;

  return {
    path: '/builder/operations/task-management',
    taskManagementTab: 'taskTemplate',
    templateTab
  };
}
